@file:OptIn(ExperimentalUuidApi::class)

package todo.pages

import androidx.compose.runtime.*
import app.AppProperties
import com.questions.model.Question
import com.questions.model.UserScore
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
//import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text
import kotlin.uuid.ExperimentalUuidApi

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json

import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Label
import org.w3c.dom.HTMLScriptElement
import org.w3c.fetch.RequestInit
import kotlin.js.json

val deviceId: String = ""
val logo = "logo.jpg"

@Page
@Composable
fun HomePage() {


    val context = rememberPageContext()
    // Get URL parameters
    val params = context.route.params

    // You can access specific parameters like this:
    val activateCode = params["activateCode"] // will return null if parameter doesn't exist
    val email = params["email"]
    val resetCode = params["resetCode"]

    console.log("activateCode: $activateCode")
    console.log("email: $email")

    loadGoogleAuthScript()

    // NEW: Provide the Google auth POST endpoint to the JS script
    LaunchedEffect(Unit) {
        // apiEndpoint is already used elsewhere in this file
        window.asDynamic().googleAuthPostUrl = apiEndpoint + "/api/google-auth"
    }

    if(!activateCode.isNullOrBlank() && !email.isNullOrBlank()) {
        activateAccount(activateCode, email, onActivateSuccess =
        {email: String, userId: String ->
            println("Account activated for email: $email, userId: $userId")
            window.localStorage.setItem("username", email)
            window.localStorage.setItem("deviceId",email)
            window.localStorage.setItem("userId",userId)
            context.router.navigateTo("/")
        }
        )
        return
    }


    var username by remember { mutableStateOf("") }
    var isLoggedIn by remember { mutableStateOf(false) }
    // NEW: controls visibility of the credentials panel (Login + Register)
    var showCredentialsLoginPanel by remember { mutableStateOf(false) }

    val storedUser = window.localStorage.getItem("username")
    isLoggedIn = !storedUser.isNullOrBlank()


    var isMobile by remember { mutableStateOf(false) }
    var showSideContent by remember { mutableStateOf(false) } // <-- NEW

    LaunchedEffect(Unit) {
        window.asDynamic().showSideContent = { show: Boolean ->
            // Update the Compose state from JS
            showSideContent = show
        }
    }

    // Set up breakpoint detection
    LaunchedEffect(Unit) {
        isMobile = window.innerWidth <= 480
        console.log("isMobile: $isMobile - innerWidth: ${window.innerWidth}")
        window.onresize = {
            console.log("resized-it:" + it)
            //invoke js function to check if it is mobile
        }
    }

    // Update isLoggedIn state based on localStorage on component mount
    LaunchedEffect(Unit) {
        val storedUser = window.localStorage.getItem("username")
        isLoggedIn = !storedUser.isNullOrBlank()
    }

    Column(
        modifier = MainContainer.toModifier()
            .width(100.percent)
            .height(100.vh)  // Set height to 100% viewport height
            .overflow(Overflow.Hidden)  // Prevent scrolling
    ) {
        // Header Box
        Box(
            Modifier
                .fillMaxWidth()
                .backgroundColor(rgb(0, 0, 0))
                .color(rgb(256, 256, 256))
                .height(if(isMobile) 5.vh else 9.vh)
                .padding(0.px)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().height(12.percent).margin(top=if(isMobile)5.percent else 2.percent),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Link("/") {
                    Image(
                        src = logo,
                        alt = "Logo",
                        modifier = Modifier.width(5.vh).height(5.vh)
                    )
                }
                Row(
                    modifier = Modifier.margin(right = 12.px),
                    horizontalArrangement = Arrangement.End,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (isLoggedIn || !window.localStorage.getItem("username").isNullOrBlank()) {
                        UserOnHeader(
                            isLoggedIn = isLoggedIn,
                            onLogout = {
                                isLoggedIn = false
                                username = ""
                                context.router.navigateTo("/")
                            }
                        )
                    }
                    Link("https://play.google.com/store/apps/details?id=com.criticalquestions") {
                        Image(
                            src = "images/google_play.png",
                            alt = "Get it on Google Play",
                            modifier = Modifier
//                                .width(if (isMobile) 4.vh else 5.vh)
                                .height(if (isMobile) 5.vh else 6.vh)
                                .margin(left = 24.px)
                        )
                    }
                }
            }
        }

        // Main content area - This should take remaining space without scrolling
        Box(
            Modifier
                .fillMaxWidth()
                .height(if(isMobile) 80.vh else 91.vh)  // Adjust height based on header
                .overflow(Overflow.Hidden)  // Prevent main content scrolling
        ) {
            Row(
                Modifier
                    .fillMaxWidth()
                    .padding(top = 0.px, bottom = 0.px)
//                    .width(40.percent)
                    .gap(8.px)
//                    .maxWidth(100.percent)
                    .alignItems(AlignItems.Start)
            ) {

                // Main Content
                Column(
                    Modifier
                        .backgroundColor(rgb(255, 255, 255))
                        .padding(0.px)
                        .position(Position.Absolute)
                        .width(100.percent)
                        .height(100.percent)
                        .borderRadius(8.px)
                        .boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 4.px, color = rgba(0,0,0,0.1))
                ) {

                    Row(
                        modifier = Modifier.fillMaxWidth().gap(8.px).width(100.percent)
                            .height(100.percent).alignItems(AlignItems.Start),
                        horizontalArrangement = Arrangement.Center

                    ) {
                        Column(
                            Modifier.fillMaxWidth().fontSize(18.px),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            // Login Form
                            if (!isLoggedIn) {
                                Div(
                                    Modifier
                                        .width(if (isMobile) 95.percent else 70.percent)
                                        .margin(25.px)
                                        .textAlign(TextAlign.Center).fontWeight(FontWeight.Bold)
                                        .fontSize(20.px)
                                        .toAttrs()
                                ) {
                                    Text("Welcome to Critical Thinker!")
                                }
                                Div(
                                    Modifier.margin(left = 40.px, right = 40.px)
                                        .textAlign(TextAlign.Center).toAttrs()
                                ) {
                                    val descriptionLines = listOf(
                                        "Think more clearly. Question better. Avoid being misled.",
                                        "This app helps you develop real critical thinking skills by practicing how to identify logical fallacies, cognitive biases, weak arguments, and flawed reasoning.",
                                        "Instead of memorizing theory, you’ll engage with practical questions that challenge how you think.",
                                        "",
                                        "• Recognize common logical fallacies",
                                        "• Identify cognitive biases in everyday thinking",
                                        "• Evaluate arguments more effectively",
                                        "• Understand cause and effect more clearly",
                                        "• Consider alternative explanations and perspectives",
                                        "",
                                        "Each question is designed to help you slow down, reflect, and think more rigorously.",
//                                        "\uD83C\uDFAF Who this is for:",
//                                        "• Students and lifelong learners",
//                                        "• Professionals who make decisions and analyze information",
//                                        "• Anyone who wants to think more clearly and independently",
//                                        "",
//                                        "\uD83D\uDCA1 Why this app is different:",
//                                        "• Focuses on real reasoning skills, not trivia",
//                                        "• Encourages reflection, not guesswork",
//                                        "• No distractions — just meaningful practice",
//                                        "• Built around concepts used in philosophy, science, and critical analysis",
//                                        "",
                                        "This is not about getting a high score. It’s about improving how you think.",
                                        )

                                    descriptionLines.forEachIndexed { index, line ->
                                        Text(line)
                                        if (index != descriptionLines.lastIndex) org.jetbrains.compose.web.dom.Br()
                                    }
                                }
                                Column {
                                    if (!resetCode.isNullOrBlank() && !email.isNullOrBlank()) {
                                        Box(CardStyle.toModifier()) {
                                            ResetPassForm(email = email, resetCode = resetCode,
                                                onSetNewPasswordSuccess = { email: String, resetCode: String, userId: String ->
                                                    console.log("Reset password success for email: $email, resetCode: $resetCode")
                                                    isLoggedIn = true
                                                    username = email
                                                    context.router.navigateTo("/")
                                                    window.localStorage.setItem("username", email)
                                                    window.localStorage.setItem("deviceId", email)
                                                    window.localStorage.setItem("userId", userId)
                                                }
                                            )
                                        }
                                    } else {
//                                    if(SiteConfig.enterAsGuest) {
//                                        Box(CardStyle.toModifier().align(Alignment.CenterHorizontally)
//                                            .margin(top=20.px, bottom = 0.px)
//                                            .padding(top=20.px, bottom = 0.px)) {
//                                            Label() {
//                                                Button (attrs = Modifier.toAttrs() {
//                                                    onClick {
//                                                        isLoggedIn = true
//                                                        username = "guest"
//                                                        context.router.navigateTo("/")
//                                                        window.localStorage.setItem("username", username)
//                                                        window.localStorage.setItem("deviceId", username) }
//                                                 }
//                                                )
//                                                { Text("Enter as Guest") }
//                                            }
//                                        }
//                                    }
                                        Div(
                                            Modifier.height(5.vh)
                                                .align(Alignment.CenterHorizontally)
                                                //width(100.percent).height(86.vh).borderRadius(0.px)
                                                //.margin(top = 0.px)
                                                .attr("id", "g_id_onload")
                                                .attr("data-auto_prompt", "false")
                                                .attr("data-callback", "handleCredentialResponse")
                                                .attr(
                                                    "data-client_id",
                                                    "106656672549-jhg3ge7n5a1f54ahik3no2blq17ubj6d.apps.googleusercontent.com"
                                                )
                                                .textAlign(TextAlign.Center).toAttrs()
                                        )
                                        Div(
                                            Modifier
                                                //width(100.percent).height(86.vh).borderRadius(0.px)
                                                .attr("class", "g_id_signin").toAttrs()
                                        )
                                        LaunchedEffect(Unit) {
                                            if (!isLoggedIn) {
                                                console.log("not logged in")
                                                val reloaded =
                                                    window.sessionStorage.getItem("reloadedOnce")
                                                if (reloaded != "true") {
                                                    window.sessionStorage.setItem(
                                                        "reloadedOnce",
                                                        "true"
                                                    )
                                                    window.location.reload()
                                                } else {
                                                    window.sessionStorage.removeItem("reloadedOnce")
                                                }
                                            }
                                        }
//                                    Box(CardStyle.toModifier().align(Alignment.CenterHorizontally).margin(top = 16.px)) {
//                                        Link("#", variant = null) {
//                                            Text("Login with user and password")
//                                        }
//                                    }
                                        if (SiteConfig.enterAsGuest) {
                                            Button(attrs = Modifier.toAttrs() {
                                                onClick {
                                                    isLoggedIn = true
                                                    username = "guest"
                                                    context.router.navigateTo("/")
                                                    window.localStorage.setItem(
                                                        "username",
                                                        username
                                                    )
                                                    window.localStorage.setItem(
                                                        "deviceId",
                                                        username
                                                    )
                                                }
                                            }
                                            )
                                            { Text("Enter as Guest") }
                                        }
                                        Button(
                                            attrs = Modifier.margin(top = 8.px).toAttrs {
                                                onClick { showCredentialsLoginPanel = true }
                                            }
                                        ) { Text("Login with user and password") }

                                        if (showCredentialsLoginPanel) {
                                            Box(CardStyle.toModifier()) {
                                                LoginForm(
                                                    onLoginSuccess = { a: String, b: String, c: String ->
                                                        isLoggedIn = true
                                                        username = a
                                                        context.router.navigateTo("/")
                                                        window.localStorage.setItem("username", a)
                                                        window.localStorage.setItem("deviceId", b)
                                                        window.localStorage.setItem("userId", c)
                                                    }
                                                )
                                            }
                                            Box(CardStyle.toModifier()) {
                                                RegisterForm(
                                                    onRegisterSuccess = {
                                                    }
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                            Column {
                                if (isLoggedIn) {
                                    HomePage2Test(true, onLogout = { isLoggedIn = false })
                                }

                            }
                        }
                    }
                }

                // Side Content
                if (isLoggedIn) {
                    if (!isMobile) {
                        // Desktop: show as before
                        Column(
                            Modifier
                                .position(Position.Absolute)
                                .maxHeight( 400.px)
//                        .backgroundColor(rgb(256, 256, 256))
                                .padding(8.px)
                                .zIndex(2)
                                .margin(left=65.percent)
//                        .alignItems(AlignItems.Start)
                            //.borderRadius(8.px)
                            //.boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 4.px, color = rgba(0,0,0,0.05))
                        ) {
                            //SideContent()
                        }
                    } else {
                        // Mobile: show as overlay/modal
                        Box(
                            Modifier
                                .position(Position.Fixed)
                                .top(0.px)
                                .left(0.px)
                                .width(90.vw)
                                .height(80.vh)
                                .backgroundColor(rgba(0, 0, 0, 0.5))
                                .zIndex(if (showSideContent) 101 else -1) // Show only when `showSideContent` is true
                                .onClick { /*showSideContent = false*/ }
                        ) {
                            Column(
                                Modifier
                                    .backgroundColor(Colors.White)
                                    .padding(2.px)
                                    .margin(top = 0.px, left = 0.px, right = 0.px)
                                    .borderRadius(0.px)
                                    .width(90.vw)
                                    .maxHeight(80.vh)
                                    .position(Position.Relative)
                                    .zIndex(if (showSideContent) 101 else -1)
                                    .onClick { /* prevent modal close on content click */ },
                                horizontalAlignment = Alignment.End
                            ) {

                                //SideContent(onCloseWindow = { showSideContent = false})
                            }
                        }
                    }
                }
            }
        }


    }
}

fun JsInteropPage2(deviceId: String) {

    loadYaireoScript() {
        console.log("yaireo loaded")
    }
    loadMyScripts(onLoaded =  {
        js("setDeviceId")(deviceId)
    })
}

fun loadYaireoScript(onLoaded: () -> Unit = {}) {

    val jqueryScript = window.document.createElement("script") as HTMLScriptElement
    jqueryScript.setAttribute("src", "https://cdn.jsdelivr.net/npm/@yaireo/tagify")
    jqueryScript.setAttribute("src", "scripts/yaireo.js")
    jqueryScript.setAttribute("type", "text/javascript")
    jqueryScript.onload = {
        onLoaded()
    }
    window.document.head?.appendChild(jqueryScript)
    console.log("Yaireo loaded")
}


@Composable
fun HomePage2Test(isLoggedIn: Boolean, onLogout: () -> Unit) {


    LaunchedEffect(Unit) {
        JsInteropPage2(deviceId)
    }

    var currentQuestionIndex by remember { mutableStateOf(0) }
    var selectedAnswers by remember { mutableStateOf(setOf<Int>()) }
    var showResult by remember { mutableStateOf(false) }
    var gotQuestions by remember { mutableStateOf(false) }
    var correctAnswers by remember { mutableStateOf(0) }
    var wrongAnswers by remember { mutableStateOf(0) }

    // NEW: make questions stateful so we can clear & refetch
    var questions by remember { mutableStateOf<List<Question>>(emptyList()) }
    // NEW: key to trigger refetch
    var refreshKey by remember { mutableStateOf(0) }
    // NEW: restarting flag & message
    var isRestarting by remember { mutableStateOf(false) }
    var restartMsg by remember { mutableStateOf<String?>(null) }

    // Helper to jump to a different question (random, not the same index)
    fun jumpToDifferentQuestion() {
        if (questions.size <= 1) return
        var newIndex = currentQuestionIndex
        // Try up to a few times to pick a different index
        repeat(3) {
            val candidate = (0 until questions.size).random()
            if (candidate != currentQuestionIndex) {
                newIndex = candidate
                return@repeat
            }
        }
        currentQuestionIndex = newIndex
        selectedAnswers = emptySet()
        showResult = false
    }

    LaunchedEffect(questions.size) {
        if (questions.isNotEmpty() && currentQuestionIndex >= questions.size) {
            currentQuestionIndex = 0
        }
    }

    Column(
        modifier = MainContainer.toModifier()
            .fillMaxWidth() // Make sure column takes full width
            .height(100.vh)
            .margin(0.px) // Remove margin
    ) {
        var username = window.localStorage.getItem("username") ?: ""
        var userId = window.localStorage.getItem("userId") ?: ""

        // CHANGED: re-fetch tied to refreshKey
        LaunchedEffect(refreshKey) {
            gotQuestions = false
            restartMsg = null
            try {
//                window.fetch("/api/config")
//                    .then { response ->
//                        if (response.ok) response.text()
//                        else throw Error("Failed to load config")
//                    }
//                    .then { content ->
//                        appProperties = Json.decodeFromString<AppProperties>(content)
//                        apiEndpoint = appProperties.apiEndpoint ?: apiEndpoint
//                    }
//                    .catch { error ->
//                        console.error("Error loading config: $error")
//                        //apiEndpoint = "http://localhost:8080/"
//                    }

                //TODO - userScore should not be available to everyone. Use userId and not email
                if(username.isNotBlank() && !username.equals("guest")) {
                    val response = window.fetch("/api/get-user-score?userId=$userId").await()
                    if (response.ok) {
                        val questionsJson = response.text().await()
                        var userScore = Json.decodeFromString<UserScore>(questionsJson)
                        correctAnswers = userScore.correct
                        wrongAnswers = userScore.wrong
                        console.log("Fetched userScore: ${userScore} ")
                    }
                } else {
                    correctAnswers = 0
                    wrongAnswers = 0
                }

                println("Fetching questions from API...")
                var apiUrl = "/api/get-questions"
                if (username.isNotBlank() && username != "guest") apiUrl += "?userId=$userId"
                val qResp = window.fetch(apiUrl).await()
                if (qResp.ok) {
                    val questionsJson = qResp.text().await()
                    var fetched = Json.decodeFromString<List<Question>>(questionsJson)
//                    if (appProperties.shuffleQuestions) fetched = fetched.shuffled()
                    questions = fetched
                } else {
                    questions = emptyList()
                    console.error("Failed to fetch questions: ${qResp.status}")
                }
            } catch (e: Exception) {
                console.error("Error fetching questions:", e.message)
                questions = emptyList()
            } finally {
                gotQuestions = true
                isRestarting = false
            }
        }

        // NEW: restart logic
        fun startAgain() {
            if (isRestarting) return
            isRestarting = true
            restartMsg = null

            // Optimistic local reset BEFORE list is accessed again
            gotQuestions = false          // so UI shows "Loading" and skips indexing
            currentQuestionIndex = 0
            selectedAnswers = emptySet()
            showResult = false
            correctAnswers = 0
            wrongAnswers = 0
            questions = emptyList()


            val userId = window.localStorage.getItem("userId") ?: ""
            window.fetch(
                apiEndpoint + "/api/delete-user-answers",
                RequestInit(
                    method = "POST",
                    headers = json(
                        "Content-Type" to "application/json",
                        "Accept" to "application/json"
                    ),
                    body = """{"recordId":"$userId", "email":"", "app":"", "deviceId":"", "password":""}"""
                )
            ).then { resp ->
                resp.text().then { body ->
                    if (!resp.ok) {
                        console.warn("Delete answers failed: $body")
                        restartMsg = "Restarted (delete failed)."
                    } else {
                        restartMsg = "Restarted."
                        // Trigger refetch (LaunchedEffect(refreshKey))
                        refreshKey++
                    }
                }
            }.catch {
                console.error("Delete answers error: $it")
                restartMsg = "Restarted (offline)."
            }
        }

        Box(
            Modifier
                .fillMaxWidth() // Make box take full width
                .weight(1f)
                .padding(16.px)
                .backgroundColor(rgb(208, 209, 210))
                .borderRadius(8.px)
                .padding(16.px)
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                if( !gotQuestions) {
                    Text("Loading questions...")
                    Image(src="logo.jpg", alt="Loading", modifier = Modifier.width(50.vh).height(50.vh))
                    return@Column
                }

                // SAFEGUARD: questions may still be empty right after restart before fetch completes
                if (questions.isEmpty()) {
                    Text("No questions loaded.")
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = { startAgain() },
                        enabled = !isRestarting,
                        modifier = Modifier
                            .margin(top = 16.px)
                            .backgroundColor(rgb(220, 53, 69))
                            .color(Colors.White)
                    ) { Text(if (isRestarting) "..." else "Retry Load") }
                    restartMsg?.let { Text(it) }
                    return@Column
                }

                // GUARANTEE: index within bounds
                if (currentQuestionIndex >= questions.size) currentQuestionIndex = 0

                val currentQuestion = questions[currentQuestionIndex]

                org.jetbrains.compose.web.dom.Div(
                    attrs = {
                        style {
                            property("text-align", "center")
                            property("margin-bottom", "16px")
                        }
                    }
                ) {
                    Label(attrs = Modifier.toAttrs {
                        attr("id", "question")
                    }
                    ){
                        Text(currentQuestion.question)
                    }
                }
                LaunchedEffect(currentQuestion.question) {
                    val setHtml = js("setHtml") as? (String) -> Unit
                    setHtml?.invoke(currentQuestion.question)
                }

                val answers: List<Pair<Int, String>> = listOf(
                    1 to currentQuestion.answer1,
                    2 to currentQuestion.answer2,
                    3 to currentQuestion.answer3,
                    4 to currentQuestion.answer4
                ).filter { (_, text) -> text.trim().isNotBlank() }

                answers.forEach { (origIndex, text) ->
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = {
                            if (!showResult) {
                                selectedAnswers = if (selectedAnswers.contains(origIndex)) {
                                    selectedAnswers - origIndex
                                } else {
                                    selectedAnswers + origIndex
                                }
                            }
                        },
                        modifier = Modifier
                            .fillMaxWidth(80.percent)
                            .whiteSpace(WhiteSpace.Normal)
                            .margin(bottom = 8.px)
                            .padding(top = 12.px, bottom = 12.px, left = 16.px, right = 16.px)
                            .minHeight(40.px)
                            .styleModifier { property("height", "auto") }
                            .backgroundColor(
                                when {
                                    !showResult && selectedAnswers.contains(origIndex) -> rgb(220, 220, 220)
                                    !showResult -> rgb(255, 255, 255)
                                    selectedAnswers.contains(origIndex) && currentQuestion.rightAnswer.contains(origIndex.toString()) -> rgb(40, 167, 69)
                                    selectedAnswers.contains(origIndex) -> rgb(220, 53, 69)
                                    currentQuestion.rightAnswer.contains(origIndex.toString()) && showResult -> rgb(40, 167, 69)
                                    else -> rgb(255, 255, 255)
                                }
                            )
                            .color(
                                when {
                                    showResult && (selectedAnswers.contains(origIndex) || currentQuestion.rightAnswer.contains(origIndex.toString())) -> rgb(255, 255, 255)
                                    else -> rgb(33, 37, 41)
                                }
                            )
                    ) {
                        Text(text)
                    }
                }

                if (!showResult && selectedAnswers.isNotEmpty()) {
                    Spacer()
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = {
                            showResult = true

                            // Add debugging to see what's being compared
                            val selectedAnswerStrings = selectedAnswers.map { it.toString() }.toSet()
                            val rightAnswerSet = currentQuestion.rightAnswer.toSet()

                            console.log("Selected answers: $selectedAnswerStrings")
                            console.log("Right answers: $rightAnswerSet")
                            console.log("Equal? ${selectedAnswerStrings == rightAnswerSet}")

                            // Try a more lenient comparison - trim and compare each element
                            val normalizedSelected = selectedAnswerStrings.map { it.trim() }.toSet()
                            val normalizedRight = rightAnswerSet.map { it.trim() }.toSet()

                            console.log("Normalized selected: $normalizedSelected")
                            console.log("Normalized right: $normalizedRight")
                            console.log("Normalized equal? ${normalizedSelected == normalizedRight}")

                            // Check individual items
                            normalizedSelected.forEach { sel ->
                                console.log("Selected item '$sel' in right answers? ${normalizedRight.contains(sel)}")
                            }

                            normalizedRight.forEach { right ->
                                console.log("Right item '$right' in selected? ${normalizedSelected.contains(right)}")
                            }

                            // Use the normalized comparison for correctness check
                            if (normalizedSelected == normalizedRight) {
                                correctAnswers++
                            } else {
                                wrongAnswers++
                            }
                        },
                        modifier = Modifier.backgroundColor(rgb(40, 167, 69)).color(Colors.White)
                            .margin(top = 16.px)
                    ) {
                        Text("Check Answer")
                    }
                } else if (showResult && currentQuestionIndex < questions.size - 1) {
                    Spacer()
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = {
                            saveAnswer(selectedAnswers.toList(), window.localStorage.getItem("username")?:"unknown",
                                window.localStorage.getItem("userId")?:"unknown",
                                selectedAnswers.map { it.toString() }.toSet() == currentQuestion.rightAnswer.toSet(),
                                currentQuestion.questionId)
                            console.log("Moving to question index: $currentQuestionIndex")
                            if (currentQuestionIndex < questions.size - 1) {
                                currentQuestionIndex++
                                selectedAnswers = setOf()
                                showResult = false

                            }
                        },
                        modifier = Modifier.backgroundColor(rgb(0, 123, 255)).color(Colors.White)
                            .margin(top = 16.px)
                    ) {
                        Text("Next Question")
                    }
                }

                // NEW: Show "Different Question" only before answering
                if (!showResult) {
                    Spacer()
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = {
                            jumpToDifferentQuestion()
                        },
                        modifier = Modifier
                            .backgroundColor(rgb(108, 117, 125))
                            .color(Colors.White)
                            .margin(top = 12.px)
                    ) {
                        Text("Different Question")
                    }
                }

                if (currentQuestion.rightAnswer.size > 1 && !showResult) {
                    Spacer()
                    Text("Select all correct answers (multiple selection possible)"
//                        ,  Modifier.color(rgb(108, 117, 125)).fontSize(14.px)
                                        )
                }

                // Show explanation after checking the answer
                if (showResult) {
                    Spacer()
                    // Render explanation text below the options
                    // You can style this as needed
                    val explanationText = questions[currentQuestionIndex].explanation
                    if (explanationText.isNotBlank()) {
                        org.jetbrains.compose.web.dom.Div(
                            attrs = {
                                style {
                                    property("margin-top", "12px")
                                    property("padding", "12px")
                                    property("background-color", "rgb(245, 245, 245)")
                                    property("border-radius", "6px")
                                    property("color", "rgb(33,37,41)")
                                }
                            }
                        ) {
                            Text("Explanation:")
                            Spacer()
                            Text(explanationText)
                        }
                    }
                }

                Spacer()
                Spacer()
                Text(if (showResult && currentQuestionIndex >= questions.size - 1) "Sorry, no more questions. Contact Nuno Feliciano (nfeliciano@gmail.com) for more questions" else "")
                Spacer()
                Row(
                    modifier = Modifier.fillMaxWidth(80.percent),
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text("Score: $correctAnswers correct, $wrongAnswers wrong")
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = { startAgain() },
                        enabled = !isRestarting,
                        modifier = Modifier
                            .backgroundColor(rgb(10, 60, 150))
                            .color(Colors.White)
                            .margin(25.px)
                    ) { Text(if (isRestarting) "..." else "Start Again") }
                }
                restartMsg?.let { Text(it) }
            }
        }

        SiteFooter()
    }
}

fun saveAnswer(answers: List<Int>, user: String, userId: String, correct : Boolean, questionId : Double){

    console.log("Saving answer for user: $user, answers: $answers, correct: $correct, questionId: $questionId")
    window.fetch(
        apiEndpoint + "/api/save-answer",
        RequestInit(
            method = "POST",
            headers = json("Content-Type" to "application/json","Accept" to "application/json"),
            body = "{\"answers\": [${answers.joinToString(",") { "\"$it\"" }}], " +
                    "\"user\": \"$user\", \"correct\": $correct, \"questionId\": \"$questionId\"" +
                    ", \"userId\": \"$userId\"" +
//                    ", \"answerTime\": \"${kotlinx.datetime.Clock.System.now()}\"" +
            "}"
        )
    ).then { response ->
        response.text().then { body ->
            if (response.ok) {
                console.log("Saved answer.")
            } else {
                console.log("Error response body: $body")
                body
            }
        }
    }
}
